import { createSlice } from "@reduxjs/toolkit";

const dummyData1 = [
  { id: 1, name: 'Item 1', value: 12 },
  { id: 2, name: 'Item 2', value: 10 },
  { id: 3, name: 'Item 3', value: 3 },
];

// const dummyData2 = [
//   { id: 1, name: 'Item 1', value: 15 },
//   { id: 2, name: 'Item 2', value: 3 },
//   { id: 3, name: 'Item 3', value: 10 },
// ];

// const dummyData3 = [
//   { id: 1, name: 'Item 1', value: 10 },
//   { id: 2, name: 'Item 2', value: 12 },
//   { id: 3, name: 'Item 3', value: 4 },
// ];

export const actionsApiSlice = createSlice({
  name: 'actionData',
  initialState: {
    data: dummyData1,
    loading: false,
    error: null,
  },
  reducers: {
    fetchDataStart: state => {
      state.loading = true;
      state.error = null;
    },
    fetchDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchDataStart, fetchDataSuccess, fetchDataFailure } = actionsApiSlice.actions;

export const loaderSlice = createSlice({
  name: 'loader',
  initialState: { isLoading: false },
  reducers: {
    loaderReducer: (state, action) => {
      state.isLoading = action.payload;
    }
  }
});



export const dpdSlice = createSlice({
  name: 'dpd',
  initialState: { data: {} },
  reducers: {
    dpdReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const timelineSlice = createSlice({
  name: 'dpd',
  initialState: { data: [] },
  reducers: {
    timelineReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const filterSlice = createSlice({
  name: 'filter',
  initialState: {data: []},
  reducers: {
    filterReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const actionsSlice = createSlice({
  name: 'actions',
  initialState: {
    data: {
      actionDetails: [
        
      ]
    }
  },
  reducers: {
    actionReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const ptpSlice = createSlice({
  name: 'ptp',
  initialState: {
    data: {
      actionDetails: [
        { id: 1, name: 'Item 1', value: 12 },
        { id: 2, name: 'Item 2', value: 10 },
        { id: 3, name: 'Item 3', value: 3 },
      ]
    }
  },
  reducers: {
    ptpReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const agentSlice = createSlice({
  name: 'agent',
  initialState: {
    data: [
      {
       
      },
      {
        
      }
    ]
  },
  reducers: {
    agentReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const trendSlice = createSlice({
  name: 'trend',
  initialState: {
    data: [
      {
        
      },
      {
        
      }
    ]
  },
  reducers: {
    trendReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

export const amountSlice = createSlice({
  name: 'amount',
  initialState: {
    data:{
    "paymentReceived":'',
    "paymentResults": [
        {
            
        },
        {
            
        },
        
    ]
} },
  reducers: {
    amountReducer: (state, action) => {
      state.data = action.payload;
    }
  }
});

const initialState = {
   data: []
};

export const filterValuesSlice = createSlice({
  name: 'filterValues',
  initialState,
  reducers: {
    setFilterValues: (state, action) => {
      state.filterValues = action.payload;
    },
  },
});

export const lendFilterSlice = createSlice({
  name: "lendFilter",
  initialState: { data: [] },
  reducers: {
    lendFilterReducer: (state, action) => {
      state.data = action.payload;
    }
  }
})

export const { setFilterValues } = filterValuesSlice.actions;
export default filterValuesSlice.reducer;
